module.exports = __webpack_public_path__ + "img/home_icon_jifenshangcheng.f2f26463.svg";